export default {
      id: "submitted-form-usage",
      viewBox: "0 0 148 148",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#submitted-form",
      toString: function () {
        return this.url;
      }
    }